import type { FormConfig } from '@takeshape/schema';
import last from 'lodash/last';
import toPath from 'lodash/toPath';
import upperFirst from 'lodash/upperFirst';
import { useMemo } from 'react';
import type { ImmutableMap } from '../../common/utils/immutable-types';
import type { WidgetProps } from '../types';
import { parseRef } from './refs';

export type GetWidgetTitleProps = Partial<Pick<WidgetProps, 'schema' | 'path' | 'config'>>;

export function getWidgetTitle({ schema, config, path }: GetWidgetTitleProps): string {
  return config?.get('title') ?? schema?.get('title') ?? (path ? upperFirst(last(toPath(path))) : '') ?? '';
}

export function useWidgetTitle({ schema, config, path }: GetWidgetTitleProps) {
  return useMemo(() => getWidgetTitle({ schema, config, path }), [schema, config, path]);
}

export function getOneOfOptionTitle({ schema, forms }: Pick<WidgetProps, 'schema' | 'forms'>, ref: string) {
  const { typeName } = parseRef(ref);
  const optionConfig: ImmutableMap<FormConfig> | undefined = forms?.getIn([typeName, 'default']);
  return getWidgetTitle({ config: optionConfig, schema }) || typeName;
}

export function getWidgetId({ formName, path }: Pick<WidgetProps, 'formName' | 'path'>) {
  return `${formName}-${path}`;
}
